import { Grid } from "semantic-ui-react";
import Title from "../Title/Title";
import Optionsbar from "../Optionsbar/Optionsbar";
import { useSelector } from "react-redux";
import { getMenuEnabled, getSecurityKey } from "../../features/tableData/visualSlice";
import MainComp from "../MainComp/MainComp";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";

function Home(props) {
  const securityKey = useSelector(getSecurityKey);
  const navigate = useNavigate();
  useEffect(() => {
    if(securityKey.length === 0) {
      navigate("/");
    }
  }, [securityKey, navigate]);
  
  const menuEnabled = useSelector(getMenuEnabled);
  if(securityKey.length === 0) { 
    return (<></>);
  } else {
    console.log(securityKey);
    return (
      <section style={{ height: "100vh" }}>
        <Grid columns={2}>
            <Grid.Column width={3}>
                <Optionsbar />
            </Grid.Column>
            <Grid.Column width={13}>
              {menuEnabled === "home" && <Title />}
              <MainComp />
            </Grid.Column>
        </Grid>
      </section>
    );
  }
}

export default Home;
